<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pV0d0P/tc-custom/9781618683649.jpg?1704313205538" alt="This image is the cover for the book Contagious Chaos, The Contagium Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Contagious Chaos, The Contagium Series
      </h1>
      <p class="bookDescription body article font2">
        <b>It’s kill or be eaten as the zombie apocalypse rages. Third in the series that dominated the Contagious Reads Horror Con Awards.</b><br/><br/>Orissa Penwell and her friends are faced with disaster, as their zombie-proof compound starts to fill and food supplies dwindle. Fuller’s soldiers and Marines have no choice but to venture out into the lawless wastelands of America where they discover a new kind of enemy.<br/><br/>What foe could be more frightening than zombies? A fortress for the criminally insane—unhinged survivors who will stop at nothing to take Orissa and her friends down for good.<br/><br/>In order serve and protect their compound, will the gang have to abandon their own moral code and engage in a war against the uninfected? How far is Orissa willing to go?<br/><br/><b>Praise for <i>Contagious</i></b><br/><br/>“I can’t give this post-apocalyptic story six stars but I wish I could!” —Tamara Rose Blodgett<br/><br/>“In her narrative storytelling, Emily Goodwin presents a refreshingly strong female hero in her zombie-infested, survival tale . . . Goodwin has shown that female writers can make flesh crawl, both living and undead, just as well as her male peers.” —<i>HorrorAddicts.net</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Emily Goodwin
      </h2>
      
      <p class="authorDescription body article">Emily Goodwin is the international best-selling author of the stand-alone novel STAY, The Guardian Legacies Series: UNBOUND, REAPER, MOONLIGHT, The Beyond the Sea Series: BEYOND THE SEA, RED SKIES AT NIGHT, and the award winning Contagium Series: CONTAGIOUS, DEATHLY CONTAGIOUS, CONTAGIOUS CHAOS, THE TRUTH IS CONTAGIOUS (Permuted Press). Emily lives with her husband, daughter, and a German Shepherd named Vader. Along with writing, Emily enjoys riding her horse, designing and making costumes, and Cosplay.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5527e9ba